<template>
  <v-container
    grid-list-xl
    :pa-3="$vuetify.breakpoint.xsOnly"
  >
    <v-layout
      wrap
    >
      <v-flex
        xs12
        sm6
        v-for="search in searches"
        :key="search.id"
      >
        <v-card
          color="blue-grey darken-2"
          class="white--text"
        >
          <v-card-title
            primary-title
          >
            <div class="headline v-card-headline">{{ search.name }}</div>
            <div class="description">{{ getDescription(search.data) }}</div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              :to="{name: 'search-view', params: { id: search.id }}"
              color="primary"
            >VIEW FEED</v-btn>

            <v-btn
              color="success"
              :disabled="isDisabled(search.id)"
              @click="activate(search.id)"
            >Make active</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm6
      >
          <v-btn
            fab
            dark
            color="primary"
            class="add-button"
            :to="{name: 'search-add'}"
          >
            <v-icon dark>add</v-icon>
          </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import mixinsPages from '@/mixins/pages'
  import mixinsSearch from '@/mixins/search'
  import SearchForm from '@/components/search/SearchForm'

  export default {
    title: 'Tracking List',
    mixins: [mixinsPages, mixinsSearch],
    components: {
      SearchForm
    },
    methods: {
      activate (id) {
        this.$store.commit('search/setActiveSearchId', id)
      },
      isDisabled (id) {
        return id === this._.get(this.activeSearch, 'id')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .headline {
    width: 100%;
  }
  .description {
    height: 40px;
    overflow: hidden;
  }
  .add-button {
    left: 50%;
    margin-left: -30px;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard.vue